'use strict';

var React = require('react');

var SvgSendIcon = function SvgSendIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m5.008 9.61-2.01-4.75c-.354-.838.506-1.676 1.336-1.3l12.163 5.53a1 1 0 0 1 0 1.82l-12.163 5.53c-.83.376-1.69-.462-1.335-1.3l2.01-4.75a1 1 0 0 0 0-.78Zm1.382-.584-1.51-3.57 9.995 4.544-9.995 4.543 1.51-3.569c.03-.074.058-.148.082-.224h3.778a.75.75 0 0 0 0-1.5h-3.778a2.5 2.5 0 0 0-.082-.224Z"
  }));
};
SvgSendIcon.displayName = "SendIcon";

exports.SvgSendIcon = SvgSendIcon;
